/* eslint-disable max-len */
import React from 'react';
import {
  Modal, ModalBody, ModalFooter, ModalHeader, Button,
} from 'reactstrap';
import PropTypes from 'prop-types';

function ModalError({
  open, onToggle, message,
}) {
  return (
    <Modal isOpen={open} toggle={onToggle}>
      <ModalHeader color="danger" toggle={onToggle}>Error</ModalHeader>
      <ModalBody>
        {message}
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={onToggle}>Close</Button>
      </ModalFooter>
    </Modal>
  );
}

ModalError.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default ModalError;
